import { components, GroupBase, OptionProps } from '@any-ui-react/select';

import { OptionContent } from './OptionContent';
import { getCountFromData } from './utils';

export const Option = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  data,
  withCounter,
  ...props
}: OptionProps<Option, IsMulti, Group> & { withCounter?: boolean }) => {
  const tagCount = getCountFromData(data);

  return (
    <components.Option {...props} data={data}>
      <OptionContent tagCount={tagCount} withCounter={withCounter}>
        {children}
      </OptionContent>
    </components.Option>
  );
};
